import { useEffect } from "react";
import type { PaidReturnMethod } from "../lib/return-fee.lib";
import { useDraftReturn } from "./use-draft-return";
import { useSetPaidReturnMethod } from "./use-set-paid-return-method";

/**
 * Records which bucket carries the return fee. Without it the backend falls back to
 * "refund" and charges an empty bucket on a credit-only basket, contradicting the
 * amount announced in the recap.
 */
export function useSyncPaidReturnMethod(
  orderId: string,
  method: PaidReturnMethod | null,
): void {
  const draft = useDraftReturn(orderId);
  const setPaidReturnMethod = useSetPaidReturnMethod(orderId);
  const current = draft?.paidReturnMethod ?? null;

  useEffect(() => {
    if (method !== current) setPaidReturnMethod(method);
  }, [method, current, setPaidReturnMethod]);
}
